import {
	getController,
	apiService as Service,
	type HpRequestPostPut,
} from '@/services/service'

const url = 'review_document_reviewers'

export const reviewDocumentReviewerService = {
	...getController<
		Api.ReviewDocumentReviewer,
		Api.ReviewDocumentReviewersPostInput,
		Api.ReviewDocumentsReviewerUpdateInput
	>(url),
	review: ({ id, data }: { id: number; data: HpRequestPostPut<unknown> }) =>
		Service.put({ url: `${url}/${id}/review`, data }),
}
